const showState = {
  state: {
    showOpenApp: true
  },
  mutations: {
    SET_SHOW_APP: (state, musicInfo) => {
      state.showOpenApp = musicInfo
    }
  }
}

export default showState
